import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { useNavigate } from 'react-router-dom';
import { textBookExamCreateFormValidation } from '../../validation/Validation';
import { competitiveExamCreateFormValidation } from '../../validation/Validation';
import { handelError } from '../../validation/validationError';
import { ZodError } from "zod";
import { ErrorMessage } from '../../validation/validationError';
import { Loader, QuestionFilter } from '../../components/ModalsCommonFunctions';

const ExamCreate = () => {
  let instituteMasterId = localStorage.getItem("instituteMasterId")
  let sectionMasterId = localStorage.getItem("sectionMasterId")
  const authorizedAxios = generateAxiosInstance()
  const authorizedAxiosCommon = generateAxiosInstanceCommon()
  const authorizedAxiosSection = generateAxiosInstanceSection()
  const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
  const [loading, setLoading] = useState(false);
  const [examType, setExamType] = useState(true);

  const initialExamPatterState = {
    exam_name: "",
    description: "",
    syllabus_structure_id: '',
    syllabus_structure_type: '',
    class_id: '',
    subject_id: '',
    lesson_id: '',
    topic_id: '',
    subtopic_id: '',
    question_ids: [],
    section_id: sectionMasterId,
  }

  const [textBookSubjectType, setTextBookSubjectType] = useState(true);
  const [lessonList, setLessonList] = useState([])
  const [examCreateData, setExamCreateData] = useState(initialExamPatterState)
  const [visible, setVisible] = useState(false)
  const [modalData, setModalData] = useState("")
  const [visibleImage, setVisibleImage] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();


  // Competitive Exam State Variables Start
  const initialCompetitiveExamPatterState = {
    exam_name: "",
    description: "",
    class_id: '',
    competitive_exam_id: '',
    competitive_exam_type: '',
    book_id: '',
    subject_id: '',
    lesson_id: '',
    topic_id: '',
    subtopic_id: '',
    question_ids: [],
    section_id: sectionMasterId,
    is_competitive: 'Y'
  }

  const [lessonListCompetitiveExam, setLessonListCompetitiveExam] = useState([])
  const [examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam] = useState(initialCompetitiveExamPatterState)
  const [errorsCompetitiveExam, setErrorsCompetitiveExam] = useState([]);
  const [competitiveExamNameList, setCompetitiveExamNameList] = useState([]);
  const [competitiveExamBookList, setCompetitiveExamBookList] = useState([])
  const [subjectListCompetitiveExam, setSubjectListCompetitiveExam] = useState([])
  const [filterbookCompetitiveExam, setFilterBookCompetitiveExam] = useState()
  const [topicListCompetitiveExam, setTopicListCompetitiveExam] = useState([])
  const [subtopicListCompetitiveExam, setSubtopicListCompetitiveExam] = useState([])
  const [questionsCompetitiveExam, setQuestionCompetitiveExam] = useState("");
  const [syTypeCompetitiveExam, setSyTypeCompetitiveExam] = useState()

  const onViewImage = (imgSrc) => {
    setModalImageSrc(imgSrc);
    setVisibleImage(true);
  };

  const handleNavigate = (route) => {
    navigate(route);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setExamCreateData((prevData) => {
      return {
        ...prevData,
        [name]: value
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleClassChange = (e) => {
    setSyType('')
    setSubjectList([])
    setLessonList([])
    setTopicList([])
    setSubtopicList([])
    setFilterBook()

    const { name, value } = e.target;
    setExamCreateData((prevData) => {
      return {
        ...prevData,
        [name]: value,
        syllabus_structure_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    setFilter((prevData) => {
      return {
        ...prevData,
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicMasterId: '',
      }
    })
    getSyllabusList(e.target.value)

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  //  question
  const initialFilterState = {
    instituteMasterId: instituteMasterId,
    sectionMasterId: sectionMasterId,
    sectionSyllabusStructureMasterId: '',
    sectionLessonMasterId: '',
    sectionTopicMasterId: '',
    sectionSubTopicMasterId: '',
    instituteSubjectMasterId: '',
    importFile: ""
  }

  const [filter, setFilter] = useState(initialFilterState);
  const [syllabusList, setSyllabusList] = useState([]);
  const [subjectList, setSubjectList] = useState([])
  const [classList, setClassList] = useState([])
  const [filterbook, setFilterBook] = useState()
  const [topicList, setTopicList] = useState([])
  const [subtopicList, setSubtopicList] = useState([])
  const [questions, setQuestion] = useState("");
  const [syType, setSyType] = useState()

  useEffect(() => {
    if (syType == "B") {
      if (filter.sectionLessonMasterId !== '') {
        setLoading(true);
        let apiUrl = `/get-section-question-bank?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (examCreateData.syllabus_structure_id) {
          apiUrl += `sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&`;
        }
        if (examCreateData.subject_id) {
          apiUrl += `instituteSubjectMasterId=${examCreateData.subject_id}&`
        }
        if (filter.sectionLessonMasterId) {
          apiUrl += `sectionLessonMasterId=${filter.sectionLessonMasterId}&`;
        }
        if (filter.sectionTopicMasterId) {
          apiUrl += `sectionTopicMasterId=${filter.sectionTopicMasterId}&`;
        }
        if (filter.sectionSubTopicMasterId) {
          apiUrl += `sectionSubTopicMasterId=${filter.sectionSubTopicMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
          .then(response => {
            setQuestion(response.data.data);
            console.log('Data:', response.data);
          })
          .catch(error => {
            setQuestion(error?.response?.data.data);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
          })
          .finally(() => {
            setLoading(false); // End loading
          })
      }
    }

    if (syType == "I") {
      if (filter.sectionLessonMasterId !== '') {
        setLoading(true);
        let apiUrl = `/get-institute-question-bank?instituteMasterId=${instituteMasterId}&`;

        if (examCreateData.syllabus_structure_id) {
          apiUrl += `instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&`;
        }
        if (examCreateData.subject_id) {
          apiUrl += `instituteSubjectMasterId=${examCreateData.subject_id}&`
        }
        if (filter.sectionLessonMasterId) {
          apiUrl += `instituteLessonMasterId=${filter.sectionLessonMasterId}&`;
        }
        if (filter.sectionTopicMasterId) {
          apiUrl += `instituteTopicMasterId=${filter.sectionTopicMasterId}&`;
        }
        if (filter.sectionSubTopicMasterId) {
          apiUrl += `instituteSubTopicMasterId=${filter.sectionSubTopicMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
          .then(response => {
            setQuestion(response.data.data);
            console.log('Data:', response.data);
          })
          .catch(error => {
            setQuestion(error?.response?.data.data);
            console.error('Error fetching data:', error);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';

          })
          .finally(() => {
            setLoading(false); // End loading
          });
      }
    }

    if (syType == "A") {
      if (filter.sectionLessonMasterId !== '') {
        setLoading(true);
        let apiUrl = `/get-question-bank?`;

        if (examCreateData.syllabus_structure_id) {
          apiUrl += `syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&`;
        }
        if (examCreateData.subject_id) {
          apiUrl += `subjectMasterId=${examCreateData.subject_id}&`
        }
        if (filter.sectionLessonMasterId) {
          apiUrl += `lessonMasterId=${filter.sectionLessonMasterId}&`;
        }
        if (filter.sectionTopicMasterId) {
          apiUrl += `topicMasterId=${filter.sectionTopicMasterId}&`;
        }
        if (filter.sectionSubTopicMasterId) {
          apiUrl += `subTopicMasterId=${filter.sectionSubTopicMasterId}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
          .then(response => {
            setQuestion(response.data.data);
            console.log('Data:', response.data);
          })
          .catch(error => {
            setQuestion(error?.response?.data.data);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
          })
          .finally(() => {
            setLoading(false); // End loading
          });
      }
    }
  }, [filter.sectionLessonMasterId, filter.sectionTopicMasterId, filter.sectionSubTopicMasterId, examCreateData.lesson_id, examCreateData.topic_id, examCreateData.subtopic_id]);

  useEffect(() => {
    const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
    authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
      .then(response => {
        setClassList(response.data.result)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });
  }, [])

  const getSyllabusList = (id) => {
    const apiUrlForSyllabus = `/get-all-syllabus-structure-grade-medium-board-wise?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${id}`;
    authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
      .then(response => {
        setSyllabusList(response.data.result)
        console.log('Data:', response.data);
      })
      .catch(error => {
        setSyllabusList([])
        console.error('Error fetching data:', error);
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';

      });
  }

  const handleInputFilterChange = (e) => {
    setFilter((prevData) => {
      return {
        ...prevData,
        [e.target.name]: e.target.value
      }
    })

    setExamCreateData((prevData) => {
      return {
        ...prevData,
        subtopic_id: e.target.value,
      }
    })
  }

  const handleSyllabusChange = (e) => {
    setSyType('')
    setLessonList([])
    setTopicList([])
    setSubtopicList([])
    setFilterBook()
    let id = e.target.value.split('').slice(0, -1).join('');
    let type = e.target.value.split('').pop()
    setSyType(e.target.value.split('').pop())

    setExamCreateData((prevData) => {
      return {
        ...prevData,
        [e.target.name]: id,
        syllabus_structure_type: type,
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (id.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
    }

    setFilter((prevData) => {
      return {
        ...prevData,
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicMasterId: '',
      }
    })

    if (type == "I") {
      const apiUrl2 = `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
        .then(response => {
          setSubjectList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubjectList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (type == "A") {

      const apiUrl2 = `/syllabus-structure-wise-subjects?id=${id}`;
      authorizedAxios && authorizedAxios.get(apiUrl2)
        .then(response => {
          setSubjectList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubjectList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }

    if (type == "B") {
      const apiUrl2 = `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`;
      authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
        .then(response => {
          setSubjectList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubjectList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }
  }

  const handleSubjectChange = (e) => {
    setTopicList([]);
    setSubtopicList([]);
    setQuestion([])

    setExamCreateData((prevData) => {
      return {
        ...prevData,
        [e.target.name]: e.target.value,
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (e.target.value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
    }

    setFilter((prevData) => {
      return {
        ...prevData,
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicMasterId: '',
      }
    })

    if (syType == "B") {
      const apiUrl = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${e.target.value}`;

      authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
        .then(response => {
          setLessonList(response.data.result)
          console.log('Data:', response.data);
          setFilterBook(1)
        })
        .catch(error => {
          setLessonList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (syType == "I") {
      const apiUrl = `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${e.target.value}`;

      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setLessonList(response.data.result)
          console.log('Data:', response.data);
          setFilterBook(1)
        })
        .catch(error => {
          setLessonList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }

    if (syType == "A") {
      const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectMasterId=${e.target.value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setLessonList(response.data.result)
          console.log('Data:', response.data);
          setFilterBook(1)
        })
        .catch(error => {
          setLessonList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }
  }

  const handleLessonChange = (e) => {
    setFilter((prevData) => {
      return {
        ...prevData,
        [e.target.name]: e.target.value,
        sectionTopicMasterId: '',
        sectionSubTopicMasterId: '',
      }
    })

    setExamCreateData((prevData) => {
      return {
        ...prevData,
        lesson_id: e.target.value,
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (e.target.value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'lesson_id'));
    }

    if (syType == "I") {
      const apiUrl = `/get-institute-lesson-wise-institute-sub-topic?id=${e.target.value}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setTopicList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (syType == "A") {
      const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setTopicList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (syType == "B") {
      const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${e.target.value}`;
      authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
        .then(response => {
          setTopicList(response.data.result)
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }
  }

  const handleTopicChange = (e) => {
    setFilter((prevData) => {
      return {
        ...prevData,
        [e.target.name]: e.target.value,
        sectionSubTopicMasterId: '',
      }
    })

    setExamCreateData((prevData) => {
      return {
        ...prevData,
        topic_id: e.target.value,
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (e.target.value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'topic_id'));
    }

    if (syType == "I") {
      const apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&instituteLessonMasterId=${filter.sectionLessonMasterId}&instituteTopicMasterId=${e.target.value}&`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setSubtopicList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setSubtopicList([])
        });
    }

    if (syType == "A") {

      const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${examCreateData.syllabus_structure_id}&subjectMasterId=${examCreateData.subject_id}&lessonId=${filter.sectionLessonMasterId}&topicId=${e.target.value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setSubtopicList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setSubtopicList([])
        });

    }

    if (syType == "B") {

      const apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&sectionLessonMasterId=${filter.sectionLessonMasterId}&sectionTopicMasterId=${e.target.value}`;
      authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
        .then(response => {
          setSubtopicList(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setSubtopicList([])
        });
    }
  }

  const createExam = async () => {
    try {
      await textBookExamCreateFormValidation.parseAsync(examCreateData);
      setErrors([]);

      setLoading(true);

      const apiUrl = `/exams`;
      const response = await authorizedAxiosSection.post(apiUrl, examCreateData);

      setExamCreateData(initialExamPatterState);
      setSyllabusList([]);
      setSubjectList([]);
      setLessonList([]);
      setTopicList([]);
      setSubtopicList([]);
      setSyType(null);
      setQuestion([]);
      setFilterBook();

      Swal.fire({ text: response.data.message });

    } catch (error) {
      if (error instanceof ZodError) {
        setErrors(error.errors);
      } else {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        Swal.fire({ text: errorMsg });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleQuestionUpdate = (number) => {
    const index = examCreateData.question_ids?.indexOf(number);
    if (index !== -1) {
      // Number is already present, remove it
      const newAge = examCreateData.question_ids?.filter(num => num !== number);
      setExamCreateData(prevState => ({ ...prevState, question_ids: newAge }));
    } else {
      // Number is not present, add it
      setExamCreateData(prevState => ({ ...prevState, question_ids: [...prevState.question_ids, number] }));
    }

    // Clear the error for the specific field being edited
    setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'question_ids'));
  };


  // From Here Competitive Exam
  const handleInputChangeCompetitiveExam = (e) => {
    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleClassChangeCompetitiveExam = (e) => {
    setSyTypeCompetitiveExam(null);
    setCompetitiveExamBookList([]);
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionCompetitiveExam([])

    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        competitive_exam_id: '',
        competitive_exam_type: '',
        book_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    getCompetitiveExamNameList(value)

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const getCompetitiveExamNameList = (id) => {
    const apiUrl = `/get-institute-grade-wise-competitive-exam-name?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${id}`;
    authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
      .then(response => {
        setCompetitiveExamNameList(response.data.result)
        console.log('Data:', response.data);
      })
      .catch(error => {
        setCompetitiveExamNameList([]);
        console.error('Error fetching data:', error);
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
      });
  }

  const handleCompetitiveExamNameChange = (e) => {
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionCompetitiveExam([])
    let id = e.target.value.split('').slice(0, -1).join('');
    let type = e.target.value.split('').pop()
    setSyTypeCompetitiveExam(type)

    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [e.target.name]: id,
        competitive_exam_type: type,
        book_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (id.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
    }

    if (type == "A") {
      const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${id}`;
      authorizedAxios && authorizedAxios.get(apiUrl2)
        .then(response => {
          setCompetitiveExamBookList(response.data.data)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setCompetitiveExamBookList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }

    if (type == "I") {
      const apiUrl2 = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${id}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
        .then(response => {
          setCompetitiveExamBookList(response.data.data)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setCompetitiveExamBookList([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }
  }

  const handleComepetitiveExamBookChange = (e) => {
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionCompetitiveExam([])

    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }

    if (syTypeCompetitiveExam == "I") {
      const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${value}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
        .then(response => {
          setSubjectListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubjectListCompetitiveExam([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (syTypeCompetitiveExam == "A") {
      const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${value}`;
      authorizedAxios && authorizedAxios.get(apiUrl2)
        .then(response => {
          setSubjectListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubjectListCompetitiveExam([])
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }
  }

  const handleComepetitiveExamSubjectChange = (e) => {
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionCompetitiveExam([])

    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }

    if (syTypeCompetitiveExam == "I") {
      const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteSubjectMasterId=${value}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setLessonListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
          setFilterBookCompetitiveExam(1)
        })
        .catch(error => {
          setLessonListCompetitiveExam([]);
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }

    if (syTypeCompetitiveExam == "A") {
      const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&subjectMasterId=${value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setLessonListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
          setFilterBookCompetitiveExam(1)
        })
        .catch(error => {
          setLessonListCompetitiveExam([]);
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }
  }

  const handleCompetitiveExamLessonChange = (e) => {
    setSubtopicListCompetitiveExam([]);

    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        topic_id: '',
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }

    if (syTypeCompetitiveExam == "I") {
      const apiUrl = `/get-institute-competitive-topic-master?instituteMasterId${instituteMasterId}&instituteCompetitiveLessonMasterId=${value}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setTopicListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setTopicListCompetitiveExam([]);
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';

        });
    }

    if (syTypeCompetitiveExam == "A") {
      const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setTopicListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setTopicListCompetitiveExam([]);
          console.error('Error fetching data:', error);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        });
    }
  }

  const handleComepetitiveExamTopicChange = (e) => {
    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        subtopic_id: '',
      }
    })

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }

    if (syTypeCompetitiveExam == "I") {
      const apiUrl = `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&instituteCompetitiveTopicMasterId=${value}`;
      authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
        .then(response => {
          setSubtopicListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubtopicListCompetitiveExam([])
          console.error('Error fetching data:', error);
        });
    }

    if (syTypeCompetitiveExam == "A") {
      const apiUrl = `/get-competitive-sub-topic?competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&competitiveTopicMasterId=${value}`;
      authorizedAxios && authorizedAxios.get(apiUrl)
        .then(response => {
          setSubtopicListCompetitiveExam(response.data.result)
          console.log('Data:', response.data);
        })
        .catch(error => {
          setSubtopicListCompetitiveExam([])
          console.error('Error fetching data:', error);
        });
    }
  }

  const handleQuestionUpdateCompetitiveExam = (number) => {
    const index = examCreateDataCompetitiveExam.question_ids?.indexOf(number);
    if (index !== -1) {
      // Number is already present, remove it
      const newAge = examCreateDataCompetitiveExam.question_ids?.filter(num => num !== number);
      setExamCreateDataCompetitiveExam(prevState => ({ ...prevState, question_ids: newAge }));
    } else {
      // Number is not present, add it
      setExamCreateDataCompetitiveExam(prevState => ({ ...prevState, question_ids: [...prevState.question_ids, number] }));
    }

    // Clear the error for the specific field being edited
    setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== 'question_ids'));
  };

  useEffect(() => {
    if (examCreateDataCompetitiveExam.lesson_id !== "") {
      if (syTypeCompetitiveExam == "I") {
        let apiUrl = `/get-institute-competitive-question-bank?instituteMasterId=${instituteMasterId}`;

        if (examCreateDataCompetitiveExam.competitive_exam_id) {
          apiUrl += `instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&`;
        }
        if (examCreateDataCompetitiveExam.q_id) {
          apiUrl += `q_id=${examCreateDataCompetitiveExam.q_id}&`;
        }
        if (examCreateDataCompetitiveExam.q_type) {
          apiUrl += `q_type=${examCreateDataCompetitiveExam.q_type}&`;
        }
        if (examCreateDataCompetitiveExam.q_level) {
          apiUrl += `q_level=${examCreateDataCompetitiveExam.q_level}&`;
        }
        if (examCreateDataCompetitiveExam.book_id) {
          apiUrl += `instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&`
        }
        if (examCreateDataCompetitiveExam.lesson_id) {
          apiUrl += `instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&`;
        }
        if (examCreateDataCompetitiveExam.topic_id) {
          apiUrl += `instituteCompetitiveTopicMasterId=${examCreateDataCompetitiveExam.topic_id}&`;
        }
        if (examCreateDataCompetitiveExam.subtopic_id) {
          apiUrl += `instituteCompetitiveSubTopicMasterId=${examCreateDataCompetitiveExam.subtopic_id}&`;
        }
        if (examCreateDataCompetitiveExam.subject_id) {
          apiUrl += `instituteSubjectMasterId=${examCreateDataCompetitiveExam.subject_id}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
          .then(response => {
            setQuestionCompetitiveExam(response.data.data)
            // console.log(response.data.data);;
          })
          .catch(error => {
            setQuestionCompetitiveExam([])
            console.error('Error fetching data:', error);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          });
      }

      if (syTypeCompetitiveExam == "A") {
        let apiUrl = `/get-competitive-question-bank?`;
        if (examCreateDataCompetitiveExam.q_id) {
          apiUrl += `q_id=${examCreateDataCompetitiveExam.q_id}&`;
        }
        if (examCreateDataCompetitiveExam.q_type) {
          apiUrl += `q_type=${examCreateDataCompetitiveExam.q_type}&`;
        }
        if (examCreateDataCompetitiveExam.q_level) {
          apiUrl += `q_level=${examCreateDataCompetitiveExam.q_level}&`;
        }
        if (examCreateDataCompetitiveExam.competitive_exam_id) {
          apiUrl += `competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&`;
        }
        if (examCreateDataCompetitiveExam.book_id) {
          apiUrl += `competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&`
        }
        if (examCreateDataCompetitiveExam.lesson_id) {
          apiUrl += `competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&`;
        }
        if (examCreateDataCompetitiveExam.topic_id) {
          apiUrl += `competitiveTopicMasterId=${examCreateDataCompetitiveExam.topic_id}&`;
        }
        if (examCreateDataCompetitiveExam.subtopic_id) {
          apiUrl += `competitiveSubTopicMasterId=${examCreateDataCompetitiveExam.subtopic_id}&`;
        }
        if (examCreateDataCompetitiveExam.subject_id) {
          apiUrl += `subjectMasterId=${examCreateDataCompetitiveExam.subject_id}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
          .then(response => {
            setQuestionCompetitiveExam(response.data.data)
            // console.log(response.data.data);
          })
          .catch(error => {
            setQuestionCompetitiveExam([])
            console.error('Error fetching data:', error);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          });
      }
    }
  }, [examCreateDataCompetitiveExam]);

  const createExamCompetitiveExam = async () => {
    try {
      await competitiveExamCreateFormValidation.parseAsync(examCreateDataCompetitiveExam);
      setErrorsCompetitiveExam([]);

      setLoading(true);

      const apiUrl = `/create-competitive-exam`;
      const response = await authorizedAxiosSection.post(apiUrl, examCreateDataCompetitiveExam);

      setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
      setCompetitiveExamNameList([]);
      setSubjectListCompetitiveExam([]);
      setLessonListCompetitiveExam([]);
      setTopicListCompetitiveExam([]);
      setSubtopicListCompetitiveExam([]);
      setSyTypeCompetitiveExam(null);
      setQuestionCompetitiveExam([]);
      setFilterBookCompetitiveExam();

      Swal.fire({ text: response.data.message });

    } catch (error) {
      if (error instanceof ZodError) {
        setErrorsCompetitiveExam(error.errors);
      } else {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        Swal.fire({ text: errorMsg });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputReset = () => {
    setSyType();
    setExamCreateData(initialExamPatterState);
    setFilter(initialFilterState);
    setFilterBook();
    setQuestion([]);
    setSyllabusList([]);
    setSubjectList([]);
    setLessonList([]);
    setTopicList([]);
    setSubtopicList([]);
    setErrors([]);
  }

  const handleInputResetCompetitiveExam = () => {
    setSyTypeCompetitiveExam();
    setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
    setFilter(initialFilterState);
    setQuestionCompetitiveExam([]);
    setFilterBookCompetitiveExam();
    setCompetitiveExamNameList([]);
    setCompetitiveExamBookList([]);
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setErrorsCompetitiveExam([]);
  }

  return (
    <>
      <Loader loading={loading} />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Header />
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                <span>Dashboard</span>
              </li>
              <li className="breadcrumb-item active"><span>Exam Create</span></li>
            </ol>
          </nav>
        </div>
        <div className="container-lg">
          <div className="row">
            <div className="card border-info mx-auto mt-3">
              <div className="card-content collpase show">
                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                  <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Exam Create</b></h4>
                </div>
                <div className="card-body ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <button className={`${examType ? 'active' : ''} btn btn-light btn-width`} onClick={() => setExamType(true)}>Text Book Exam</button>
                        </div>
                        <div className="col-md-6">
                          <button className={`${examType ? '' : 'active'} btn btn-light btn-width`} onClick={() => setExamType(false)}>Competitive Exam</button>
                        </div>
                        {/* <div className="col-md-6">
                          <button className={`${examType ? '' : 'active'} btn btn-light btn-width`} onClick={() => setExamType(false)}>Competitive Exam</button>
                        </div> */}
                      </div>

                      {examType === true && <div className="row">
                        <div className="col-md-12 view_content_radio_btn">
                          <label for="textBookSubjectType" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Subject Type :</label>
                          <label>
                            <input type="radio" name="textBookSubjectType" value={true} checked={textBookSubjectType === true} onChange={() => setTextBookSubjectType(true)} /> &nbsp;Single Subject
                          </label>
                          <label>
                            <input type="radio" name="textBookSubjectType" value={false} checked={textBookSubjectType === false} onChange={() => setTextBookSubjectType(false)} /> &nbsp;Multiple Subject
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                          <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={(e) => handleInputChange(e)} value={examCreateData.exam_name} />
                          <ErrorMessage errors={errors} field="exam_name" />
                        </div>

                        <div className="col-md-6">
                          <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description </label>
                          <input type="text" className="form-control" id={`description`} name='description' onChange={(e) => handleInputChange(e)} value={examCreateData.description} />
                          <ErrorMessage errors={errors} field="description" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                          <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChange} value={examCreateData.class_id}>
                            <option selected value={''} disabled>Select Class</option>
                            {
                              classList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errors} field="class_id" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                          <select required class="form-select" aria-label="Default select example" name='syllabus_structure_id' onChange={handleSyllabusChange} value={examCreateData.syllabus_structure_id + syType}>
                            <option selected value={''} >Select Syllabus</option>
                            {
                              syllabusList?.map((syllabus) => {
                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errors} field="syllabus_structure_id" />
                        </div>

                        {syType == "B" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>
                        </>}

                        {syType == "I" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>
                        </>
                        }

                        {syType == "A" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                              <option selected value={''}>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>
                        </>
                        }
                      </div>}

                      {examType === false && <div className="row">
                        <div className="col-md-6">
                          <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                          <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.exam_name} />
                          <ErrorMessage errors={errorsCompetitiveExam} field="exam_name" />
                        </div>

                        <div className="col-md-6">
                          <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                          <input type="text" className="form-control" id={`description`} name='description' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.description} />
                          <ErrorMessage errors={errorsCompetitiveExam} field="description" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                          <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChangeCompetitiveExam} value={examCreateDataCompetitiveExam.class_id}>
                            <option selected value={''} disabled>Select Class</option>
                            {
                              classList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="class_id" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam :</label>
                          <select required class="form-select" aria-label="Default select example" name='competitive_exam_id' onChange={handleCompetitiveExamNameChange} value={examCreateDataCompetitiveExam.competitive_exam_id + syTypeCompetitiveExam}>
                            <option selected value={''} >Select Competitive Exam</option>
                            {
                              competitiveExamNameList?.map((competitiveExamName) => {
                                return <option style={{ color: competitiveExamName.type == "I" ? "blue" : competitiveExamName.type == "B" ? "red" : '' }} value={competitiveExamName.id + competitiveExamName.type}>{competitiveExamName?.examName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="competitive_exam_id" />
                        </div>

                        {syTypeCompetitiveExam == "A" && <div className="col-md-6">
                          <label for="book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                          <select required class="form-select" aria-label="Default select example" name='book_id' onChange={handleComepetitiveExamBookChange} value={examCreateDataCompetitiveExam.book_id}>
                            <option selected value={''} disabled>Select Book</option>
                            {
                              competitiveExamBookList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="book_id" />
                        </div>}

                        {syTypeCompetitiveExam == "I" && <div className="col-md-6">
                          <label for="book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                          <select required class="form-select" aria-label="Default select example" name='book_id' onChange={handleComepetitiveExamBookChange} value={examCreateDataCompetitiveExam.book_id}>
                            <option selected value={''} disabled>Select Book</option>
                            {
                              competitiveExamBookList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="book_id" />
                        </div>}

                        {syTypeCompetitiveExam == "I" && <>
                          <div className="col-md-6">
                            <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleComepetitiveExamSubjectChange} value={examCreateDataCompetitiveExam?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectListCompetitiveExam?.map((syllabus) => {
                                  return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                          </div>
                        </>
                        }

                        {syTypeCompetitiveExam == "A" && <>
                          <div className="col-md-6">
                            <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleComepetitiveExamSubjectChange} value={examCreateDataCompetitiveExam?.subject_id}>
                              <option selected value={''}>Select Subject</option>
                              {
                                subjectListCompetitiveExam?.map((syllabus) => {
                                  return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                          </div>
                        </>
                        }
                      </div>}

                    </div>
                  </div>
                </div>

                <div className="container-lg">
                  <div className="row">
                    <div className="card border-info mb-2 mx-auto mt-3">
                      <div className="card-content collpase show">
                        <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                          <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>Select Questions</b></h4>
                        </div>
                        <div className="card-body ">
                          <div className="row">
                            {examType == true && <div className="col-md-12">
                              {syType == "B" && <>
                                <div className="col-md-6 view_content_radio_btn">
                                  <label>
                                    <input type="radio" value="1" name="filterbook" checked={filterbook == 1} onClick={() => setFilterBook(1)} /> Lesson
                                  </label>
                                  <label>
                                    <input type="radio" value="2" name="filterbook" checked={filterbook == 2} onClick={() => setFilterBook(2)} /> Topic
                                  </label>

                                  <label>
                                    <input type="radio" value="3" name="filterbook" checked={filterbook == 3} onClick={() => setFilterBook(3)} /> Sub Topic
                                  </label>
                                </div>
                              </>}

                              {syType == "I" && <>
                                <div className="col-md-6 view_content_radio_btn">
                                  <label>
                                    <input type="radio" value="1" name="filterbook" checked={filterbook == 1} onClick={() => setFilterBook(1)} /> Lesson
                                  </label>
                                  <label>
                                    <input type="radio" value="2" name="filterbook" checked={filterbook == 2} onClick={() => setFilterBook(2)} /> Topic
                                  </label>

                                  <label>
                                    <input type="radio" value="3" name="filterbook" checked={filterbook == 3} onClick={() => setFilterBook(3)} /> Sub Topic
                                  </label>
                                </div>
                              </>
                              }

                              {syType == "A" && <>
                                <div className="col-md-6 view_content_radio_btn">
                                  <label>
                                    <input type="radio" value="1" name="filterbook" checked={filterbook == 1} onClick={() => setFilterBook(1)} /> Lesson
                                  </label>
                                  <label>
                                    <input type="radio" value="2" name="filterbook" checked={filterbook == 2} onClick={() => setFilterBook(2)} /> Topic
                                  </label>
                                  <label>
                                    <input type="radio" value="3" name="filterbook" checked={filterbook == 3} onClick={() => setFilterBook(3)} /> Sub Topic
                                  </label>
                                </div>
                              </>
                              }
                              <div className="row">
                                {syType == "B" && <div className="row">
                                  {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={filter.sectionLessonMasterId}>
                                      <option selected value={''} disabled>Select Lesson</option>
                                      {
                                        lessonList?.map((lesson) => {
                                          return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="lesson_id" />
                                  </div>}
                                  {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleTopicChange} value={filter.sectionTopicMasterId}>
                                      <option selected value={''} disabled>Select Topic</option>
                                      {
                                        topicList?.map((topic) => {
                                          return <option value={topic.id}>{topic.sectionTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="topic_id" />
                                  </div>}

                                  {filterbook == 3 && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionSubTopicMasterId' onChange={handleInputFilterChange} value={filter.sectionSubTopicMasterId}>
                                      <option selected value={''} disabled>Select Sub Topic</option>
                                      {
                                        subtopicList?.map((topic) => {
                                          return <option value={topic.id}>{topic.sectionSubTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="subtopic_id" />
                                  </div>}
                                </div>}

                                {syType == "I" && <div className="row">
                                  {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={filter.sectionLessonMasterId}>
                                      <option selected value={''} disabled>Select Lesson</option>
                                      {
                                        lessonList?.map((lesson) => {
                                          return <option value={lesson?.id}>{lesson?.instituteLessonName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="lesson_id" />
                                  </div>}
                                  {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleTopicChange} value={filter.sectionTopicMasterId}>
                                      <option selected value={''} disabled>Select Topic</option>
                                      {
                                        topicList?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.instituteTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="topic_id" />
                                  </div>}

                                  {filterbook == 3 && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionSubTopicMasterId' onChange={handleInputChange} value={filter.sectionSubTopicMasterId}>
                                      <option selected value={''} disabled>Select Sub Topic</option>
                                      {
                                        subtopicList?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.instituteSubTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="subtopic_id" />
                                  </div>}
                                </div>}

                                {syType == "A" && <div className="row">
                                  {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={filter.sectionLessonMasterId}>
                                      <option selected value={''} disabled>Select Lesson</option>
                                      {
                                        lessonList?.map((lesson) => {
                                          return <option value={lesson?.id}>{lesson?.lessonName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="lesson_id" />
                                  </div>}
                                  {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleTopicChange} value={filter.sectionTopicMasterId}>
                                      <option selected value={''} disabled>Select Topic</option>
                                      {
                                        topicList?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.topicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="topic_id" />
                                  </div>}

                                  {filterbook == 3 && <div className="col-md-6">
                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='sectionSubTopicMasterId' onChange={handleInputChange} value={filter.sectionSubTopicMasterId}>
                                      <option selected value={''} disabled>Select Sub Topic</option>
                                      {
                                        subtopicList?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.subTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errors} field="subtopic_id" />
                                  </div>}
                                </div>}

                                {examCreateData.syllabus_structure_id !== "" &&
                                  <div className="d-grid gap-2 mt-2">
                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                      <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                        {questions.length > 0 && <ErrorMessage errors={errors} field="question_ids" />}
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th scope="col"></th>
                                              <th scope="col" className='sl_no'>Sr. No.</th>
                                              <th scope='col'>Q_Level</th>
                                              <th scope='col'>Q_Type</th>
                                              <th scope='col'>Question</th>
                                              <th scope="col">Option_a</th>
                                              <th scope="col">Option_b </th>
                                              <th scope="col">Option_c</th>
                                              <th scope="col">Option_d</th>
                                              <th scope='col'>Answer</th>
                                              <th scope='col'>Solution</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {
                                              questions?.length > 0 ?
                                                questions?.map((question, index) => {
                                                  <QuestionFilter key={index} question={question}></QuestionFilter>
                                                  return (
                                                    <tr key={index}>
                                                      <td><input type='checkbox' checked={examCreateData.question_ids?.includes(question.id)} onChange={() => handleQuestionUpdate(question.id)} /></td>
                                                      <th scope="row" className='sl_no'>{index + 1}</th>
                                                      <td>{question.q_level}</td>
                                                      <td>{question.q_type}</td>
                                                      <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                      <td>{question.ans}</td>
                                                      <td>
                                                        <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                          setVisible(!visible)
                                                          setModalData(question.sol)
                                                        }}><i class="fa fa-eye" ></i></button>
                                                      </td>
                                                    </tr>
                                                  )
                                                })
                                                :
                                                (<tr>
                                                  <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                </tr>)
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                }

                                <div className='row btn-sticky' style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                  <button className="btn btn-primary col-md-6" type="button" style={{ marginRight: '20px' }} onClick={createExam}>Save</button>
                                  <button className="btn btn-danger delete_icon col-md-6" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                </div>

                              </div>
                            </div>}

                            {examType == false && <div className="col-md-12">
                              {syTypeCompetitiveExam == "I" && <>
                                <div className="col-md-6 view_content_radio_btn">
                                  <label>
                                    <input type="radio" value="1" name="filterbook" checked={filterbookCompetitiveExam == 1} onClick={() => setFilterBookCompetitiveExam(1)} /> Lesson
                                  </label>
                                  <label>
                                    <input type="radio" value="2" name="filterbook" checked={filterbookCompetitiveExam == 2} onClick={() => setFilterBookCompetitiveExam(2)} /> Topic
                                  </label>

                                  <label>
                                    <input type="radio" value="3" name="filterbook" checked={filterbookCompetitiveExam == 3} onClick={() => setFilterBookCompetitiveExam(3)} /> Sub Topic
                                  </label>
                                </div>
                              </>
                              }

                              {syTypeCompetitiveExam == "A" && <>
                                <div className="col-md-6 view_content_radio_btn">
                                  <label>
                                    <input type="radio" value="1" name="filterbook" checked={filterbookCompetitiveExam == 1} onClick={() => setFilterBookCompetitiveExam(1)} /> Lesson
                                  </label>
                                  <label>
                                    <input type="radio" value="2" name="filterbook" checked={filterbookCompetitiveExam == 2} onClick={() => setFilterBookCompetitiveExam(2)} /> Topic
                                  </label>

                                  <label>
                                    <input type="radio" value="3" name="filterbook" checked={filterbookCompetitiveExam == 3} onClick={() => setFilterBookCompetitiveExam(3)} /> Sub Topic
                                  </label>
                                </div>
                              </>
                              }
                              <div className="row">
                                {syTypeCompetitiveExam == "I" && <div className="row">
                                  {(filterbookCompetitiveExam == 1 || filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                    <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                    <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                      <option selected value={''} disabled>Select Lesson</option>
                                      {
                                        lessonListCompetitiveExam?.map((lesson) => {
                                          return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="lesson_id" />
                                  </div>}
                                  {(filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                    <label for="topic_id" className="col-form-label">Select Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleComepetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                      <option selected value={''} disabled>Select Topic</option>
                                      {
                                        topicListCompetitiveExam?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="topic_id" />
                                  </div>}

                                  {filterbookCompetitiveExam == 3 && <div className="col-md-6">
                                    <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.subtopic_id}>
                                      <option selected value={''} disabled>Select Sub Topic</option>
                                      {
                                        subtopicListCompetitiveExam?.map((subtopic) => {
                                          return <option value={subtopic?.id}>{subtopic?.competitiveSubTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="subtopic_id" />
                                  </div>}
                                </div>}

                                {syTypeCompetitiveExam == "A" && <div className="row">
                                  {(filterbookCompetitiveExam == 1 || filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                    <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                    <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                      <option selected value={''} disabled>Select Lesson</option>
                                      {
                                        lessonListCompetitiveExam?.map((lesson) => {
                                          return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="lesson_id" />
                                  </div>}
                                  {(filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                    <label for="topic_id" className="col-form-label">Select Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleComepetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                      <option selected value={''} disabled>Select Topic</option>
                                      {
                                        topicListCompetitiveExam?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="topic_id" />
                                  </div>}

                                  {filterbookCompetitiveExam == 3 && <div className="col-md-6">
                                    <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                    <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.subtopic_id}>
                                      <option selected value={''} disabled>Select Sub Topic</option>
                                      {
                                        subtopicListCompetitiveExam?.map((topic) => {
                                          return <option value={topic?.id}>{topic?.competitiveSubTopicName}</option>
                                        })
                                      }
                                    </select>
                                    <ErrorMessage errors={errorsCompetitiveExam} field="subtopic_id" />
                                  </div>}
                                </div>}

                                {examCreateDataCompetitiveExam.competitive_exam_id !== "" &&
                                  <div className="d-grid gap-2 mt-2">
                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                      <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                        {questionsCompetitiveExam.length > 0 && <ErrorMessage errors={errorsCompetitiveExam} field="question_ids" />}
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th scope="col"></th>
                                              <th scope="col" className='sl_no'>Sr. No.</th>
                                              <th scope='col'>Q_Level</th>
                                              <th scope='col'>Q_Type</th>
                                              <th scope='col'>Question</th>
                                              <th scope="col">Option_a</th>
                                              <th scope="col">Option_b </th>
                                              <th scope="col">Option_c</th>
                                              <th scope="col">Option_d</th>
                                              <th scope='col'>Answer</th>
                                              <th scope='col'>Solution</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {
                                              questionsCompetitiveExam?.length > 0 ?
                                                questionsCompetitiveExam?.map((question, index) => {
                                                  // const hasUnwantedDoubleQuotes = (value) => {
                                                  //   if (typeof value !== 'string') return false;

                                                  //   // Regex to find double quotes not in img src attribute
                                                  //   const regex = /(?:^|[^<])"(?![^<>]*<\/img>)/g;

                                                  //   // Regex to match <img> tags with double quotes in src
                                                  //   const imgTagWithSrc = /<img.*?src=".*?".*?>/g;

                                                  //   // If the value has double quotes not inside an img src or doesn't match an img tag with src, return true
                                                  //   return regex.test(value) && !imgTagWithSrc.test(value);
                                                  // };

                                                  // // Check if any of the relevant fields contain unwanted double quotes
                                                  // const hasDoubleQuotes = ['question', 'option_a', 'option_b', 'option_c', 'option_d'].some(key => hasUnwantedDoubleQuotes(question[key]));

                                                  // // If unwanted double quotes are found, do not render this question
                                                  // if (hasDoubleQuotes) return null;

                                                  <QuestionFilter key={index} question={question}></QuestionFilter>
                                                  return (
                                                    <tr key={index}>
                                                      <td><input type='checkbox' checked={examCreateDataCompetitiveExam.question_ids?.includes(question.id)} onChange={() => handleQuestionUpdateCompetitiveExam(question.id)} /></td>
                                                      <th scope="row" className='sl_no'>{index + 1}</th>
                                                      <td>{question.q_level}</td>
                                                      <td>{question.q_type}</td>
                                                      <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                      <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                      <td>{question.ans}</td>
                                                      <td>
                                                        <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                          setVisible(!visible)
                                                          setModalData(question.sol)
                                                        }}><i class="fa fa-eye" ></i></button>
                                                      </td>
                                                    </tr>
                                                  )
                                                })
                                                :
                                                (<tr>
                                                  <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                </tr>)
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div className='row btn-sticky' style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                  <button className="btn btn-primary col-md-6" type="button" style={{ marginRight: '20px' }} onClick={createExamCompetitiveExam}>Save</button>
                                  <button className="btn btn-danger delete_icon col-md-6" type="button" style={{ marginRight: "20px" }} onClick={handleInputResetCompetitiveExam}>Reset</button>
                                </div>
                              </div>
                            </div>}

                          </div>

                          {visible && <CModal
                            visible={visible}
                            onClose={() => setVisible(false)}
                            aria-labelledby="LiveDemoExampleLabel"
                            onIni
                          >
                            <div className="book book-modal">
                              <div className='table-header-like'>Solution</div>

                              <div className="page" dangerouslySetInnerHTML={{
                                __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                              }}></div>

                              <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                Close
                              </button>
                            </div>
                          </CModal>}

                          {visibleImage && (
                            <CModal
                              visible={visibleImage}
                              onClose={() => setVisibleImage(false)}
                              aria-labelledby="LiveDemoExampleLabel"
                            >
                              <div className="book book-modal">
                                <div className='table-header-like'>Image</div>
                                {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                                <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                                  Close
                                </button>
                              </div>
                            </CModal>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
};

export default ExamCreate;